import React from 'react'
import './modal.css'

export default function Modal({ isOpen, setModalOpen, children }) {
  if (isOpen) {
    return (
      <div className='backgruound-style-incluir2'>
        <div className='modal-alert-incluir2'>
          <div>{children}</div>
        </div>
      </div>
    )
  }

  return null
}



